import React from 'react';

const RollbackIcon = ({ size = 35, color = 'currentColor' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 392.619 392.619" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M254.972 143.588c-7.003-7.091-15.205-13.043-24.382-17.576-21.687-10.714-46.247-12.34-69.153-4.58-22.909 7.759-41.426 23.976-52.138 45.661-22.114 44.767-3.686 99.178 41.081 121.293 12.862 6.353 26.611 9.438 40.23 9.438 23.982 0 47.549-9.578 65.069-27.754l-21.598-20.82c-18.367 19.052-46.663 23.97-70.415 12.238-29.936-14.788-42.259-51.173-27.472-81.108 7.164-14.502 19.546-25.346 34.864-30.534 15.318-5.189 31.741-4.1 46.243 3.063 7.901 3.903 14.722 9.376 20.138 16.028"
        stroke={color}
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RollbackIcon;